module.exports = __webpack_public_path__ + "static/media/Risorsa 006.2a90bad9.svg";